import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import ProductPreviewPageState from '@features/productPreview/mobX/state/ProductPreviewPageState';
import styles from '@features/productPreview/sections/VideoCollection/VideoCollection.styles';
import { ContentVideoItemType } from '@features/productPreview/sections/ProductDescription/typescript';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import { uiState } from '@features/productPreview/mobX/state/context';
import VideoPlayer from '@components/Video/VideoPlayer';
type PropsType = {
  video: ContentVideoItemType;
  state: ProductPreviewPageState;
  classNames?: Record<string, unknown>;
};
const VideoCollection = ({
  video,
  classNames = {},
  state
}: PropsType) => {
  const [margin, setMargin] = useState(0);
  const {
    windowDimensions
  } = uiState;
  const handleVideoAction = () => {
    state.setVideoCollectionActive(true);
  };
  useEffect(() => {
    if (windowDimensions.width > 1920) {
      setMargin(0);
    } else if (windowDimensions.width > 1610) {
      setMargin((-windowDimensions.width + 1530) / 2);
    } else {
      setMargin(-40);
    }
  }, [windowDimensions]);
  return <ErrorBoundary>
      <div sx={classNames ? {
      ...styles.videoContainer,
      ...classNames
    } : styles.videoContainer(margin)}>
        {video.type === 'VIDEO_FILE' && <VideoPlayer video={video.video} playVideo={state.isVideoCollectionRunning} withSound={false} controls={true} loop={false} poster={video.thumb} onLoaded={() => handleVideoAction()} onErrorFunc={() => state.setVideoCollectionActive(false)} />}
      </div>
    </ErrorBoundary>;
};
export default observer(VideoCollection);